import { googleAnalyticsLogger } from '~/shared/services/googleAnalytics'
import { pinterestPixelService } from '~/shared/services/pinterestPixelService'
import { ISubscription } from '~/shared/types/subscriptionsTypes'

type TProps = {
  selectedSubscription?: ISubscription | null
  uuid: string
  price: number
  currency: string
}

export const logGeneralAddToCartEvents = ({
  selectedSubscription,
  uuid,
  price,
  currency,
}: TProps) => {
  if (selectedSubscription) {
    googleAnalyticsLogger.logAddingToCart(selectedSubscription)
  }

  window?.fbq?.('track', 'AddToCart', {}, { eventID: uuid })

  if (selectedSubscription) {
    pinterestPixelService.trackAddToCart({
      value: price,
      currency,
      productId: selectedSubscription.id,
      productName: selectedSubscription.product,
      productPrice: price,
    })
  }
}
